import { useEffect } from "react";
import { isRouteErrorResponse, Link, useRouteError } from "react-router";
import { Brand } from "@/components/brand";
import { FeedbackDialog } from "@/components/feedback-dialog";
import { Button } from "@/components/ui/button";
import { isStaleAppError, refreshApp, refreshAppOnce } from "@/lib/stale-app";

export function RouteError() {
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  const chunkFailed = error instanceof Error && isStaleAppError(error.message);
  // An out-of-date copy of the app: fetch the newest one without making the person tap anything.
  useEffect(() => {
    if (chunkFailed) refreshAppOnce();
  }, [chunkFailed]);
  return (
    <div className="mx-auto flex min-h-dvh max-w-md flex-col items-center justify-center px-6 text-center">
      <Brand />
      <h1 className="mt-8 text-2xl font-bold tracking-tight">
        {notFound
          ? "That page isn't here"
          : chunkFailed
            ? "GridAction was updated"
            : "Something went wrong"}
      </h1>
      <p className="mt-2 text-muted">
        {notFound
          ? "The link may be old, or the board may belong to a group you're not in."
          : chunkFailed
            ? "Reload to get the latest version."
            : "Try again in a moment. If it keeps happening, reload the app."}
      </p>
      <div className="mt-6 flex gap-2">
        {chunkFailed ? (
          <Button onClick={() => void refreshApp()}>Update now</Button>
        ) : (
          <Button asChild>
            <Link to="/app">Go home</Link>
          </Button>
        )}
        <FeedbackDialog
          defaultKind="broken"
          defaultMessage={
            notFound
              ? `A page that wouldn't open: ${window.location.pathname}`
              : `Something went wrong on ${window.location.pathname}. ${
                  error instanceof Error ? error.message.slice(0, 200) : ""
                }`.trim()
          }
          trigger={<Button variant="outline">Report this problem</Button>}
        />
      </div>
    </div>
  );
}

export function NotFound() {
  return (
    <div className="mx-auto flex min-h-dvh max-w-md flex-col items-center justify-center px-6 text-center">
      <Brand />
      <h1 className="mt-8 text-2xl font-bold tracking-tight">That page isn't here</h1>
      <p className="mt-2 text-muted">Check the link, or head back to your boards.</p>
      <Button asChild className="mt-6">
        <Link to="/app">Go home</Link>
      </Button>
    </div>
  );
}
